<div class="alert alert-success" *ngIf="alertDeleteSuccess">
    Event deleted successfully!
</div>
<div class="alert alert-success" *ngIf="alertCloseSuccess">
    Event closed successfully!
</div>
<div class="alert alert-success" *ngIf="alertCancelSuccess">
    Event cancelled successfully!
</div>
<div class="alert alert-success" *ngIf="alertCancelAllSuccess">
    Event Series cancelled successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
</div>
<div class="fonts">
    <div class="row container-fluid overall-margin">
        <div class="col-md-12" [ngClass]="{'fontFamily-margin': true}">
            <div class="col-md-12 col-xs-12 col-sm-12 heading">
                <span class="span-create-edit-hoshin color">Events</span>
                <span class="pt-2" *ngIf="(this.adminId==1 || this.adminId=='1' || this.adminId==4 || this.adminId=='4')" style="font-size: 13px;"><a href="assets/userguides/Events_SuperAdmin.pdf" download class="pl-3 download-link">User Guide</a></span>
                <span class="pt-2" *ngIf="!(this.adminId==1 || this.adminId=='1' || this.adminId==4 || this.adminId=='4')" style="font-size: 13px;"><a href="assets/userguides/Events_ChapterAdmin.pdf" download class="pl-3 download-link">User Guide</a></span>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12 p-0"  style="display:inline-flex">
                <div class="col-6 p-0">
                    <button class="btn btn-danger col-sm-6 col-md-5 col-lg-4 col-xl-3 m-1 curve-edge button-font"
                        [ngClass]="{'disableSection': showPastEventsTab}" (click)="getUpcomingEvents()">Upcoming
                    </button>
                    <button
                        class="btn btn-danger col-sm-6 col-md-5 col-lg-4 col-xl-3 m-1 curve-edge button-font margin-left"
                        [ngClass]="{'disableSection': showUpcomingEventsTab}" (click)="getPastEvents()">Past Events
                    </button>
                </div>
                <div class="col-6 text-right p-0">
                    <button type="button" class ="btn btn-danger btn-style" (click)="clearEditEventData()" routerLink="../create-event">CREATE NEW EVENT</button>
                </div>
            </div>
            <div *ngIf="showUpcomingEventsTab" class="mt-4 mb-3 ml-2 p-0 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Section to view upcoming Events.</span>
            </div>
            <div *ngIf="showPastEventsTab" class="mt-4 mb-3 ml-2 p-0 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Section to view completed Events.</span>
            </div>
        </div>
        <!-- search options -->
        <div id='included_page' class="form-outer-div col-12">
            <div class="form-group-div">
                <span>
                    <ng-select placeholder="--Select SITE--" class="custom" [items]="siteList" bindLabel="siteName"
                        bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)"></ng-select>
                </span>
            </div>
        
            <div class="form-group-div">
        
                <div>
                    <ng-select placeholder="--Select BPG--" class="custom" [items]="bpgList" bindLabel="bpgName"
                        bindValue="bpgId" [(ngModel)]="bpgId" (change)="bpgChange($event)"></ng-select>
                </div>
            </div>
        
            <div class="form-group-div">
                <ng-select placeholder="--Select Status--" class="custom" [items]="statusList" bindLabel="status"
                    bindValue="status" [(ngModel)]="status" (change)="changeStatus($event)"></ng-select>
            </div>

            <div class="form-group-div">
                <ng-select placeholder="--Select Fiscal Year--" class="custom" [items]="fyList" bindLabel="fySelected"
                    bindValue="fySelected" [(ngModel)]="fySelected" (change)="changeFYSelected($event)"></ng-select>
            </div>
        
        
            <div class="form-group-div">
                <input type="text" class="form-control keywords" autocomplete="off" id="search"
                    placeholder="Search by event name" [(ngModel)]="searchKey">
            </div>
            <div id="searchSecn" style="margin-top: 7px; display: inline-flex;">
                <button type="button" class="btn btn-danger" (click)="searchEvents()">Search</button>
                <span [ngClass]="{'disabled': !showDownloadOption}" class="download-icon mt-2 pl-3 color" (click)="downloadEventsList()"><mat-icon matTooltip="download">download</mat-icon></span>
                <span [ngClass]="{'disabled': !showDownloadOption}" class="download-icon mt-2 pl-3 color" (click)="printEvents()"><mat-icon matTooltip="print">print</mat-icon></span>
            </div>
        </div>
        <div *ngIf="showErrorMessage" class="col-md-12">
            <div class="mt-2 ml-2 p-0 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Download and Print option are only available when a BPG is selected.</span>
            </div>
        </div>
          <!-- table data -->
        <div class="col-md-12">
            <div class="mt-4">
                <p class="noDataFound text-center color" *ngIf="noDataFound"> No record found ! </p>
                <div id="tabledemo1" *ngIf="!noDataFound">
                    <div class="table-container">
                        <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}"
                            class="table table-striped" id="tabledemo">
                            <thead>
                                <tr class="tr-th">
                                    <th scope="col">Event Name</th>
                                    <th scope="col">Last Updated By</th>
                                    <th scope="col">Chapter</th>
                                    <th scope="col">Event Date</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of eventsData | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
                                    <td scope="col" style="width: 15%;">{{data.eventName}}</td>
                                    <td class="color" scope="col" style="width: 10%;">{{data.lastModifiedByEmailId}}</td>
                                    <td class="color" scope="col" style="width: 30%; white-space: nowrap;"><span class="chapter-border">{{data.siteName| ellipsis:15}} - {{data.bpgName | ellipsis:15}} </span></td>
                                    <td scope="col" style="width: 12%;">{{data.eventCreateDate | date:'MM-dd-yyyy'}}</td>
                                    <td scope="col" style="width: 8%;">{{data.eventStatus}}</td>
                                    <td scope="col" style="width: 25%;">
                                    
                                      <a (click)="viewEventDetails(data.eventId,'VIEW')" class="viewButton" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus!='NEW' && data.eventStatus!='REJECTED')"><img src="assets/images/view.png" class="image" title="View" alt="Angular Logo"></a>
                                      <a (click)="editEvent(data)" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus!='COMPLETED'&&data.eventStatus!='CLOSED'&&data.eventStatus!='CANCELLED') && (data.eventCreateDate > previousDate || (data.eventCreateDate < previousDate && data.eventStatus!='NEW' && data.eventStatus!='SCHEDULED'))" [hidden]="(data.startTime!=null && data.startTime < currentTime) && (data.eventCreateDate == currentDate)" routerLink="../create-event" class="editButton"><img src="assets/images/edit.png" class="image" title="Edit" alt="Angular Logo"></a>
                                      <a (click)="editAllEvent(data)" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&& (data.occurenceType!='once') && (data.eventStatus!='COMPLETED'&&data.eventStatus!='CLOSED'&&data.eventStatus!='CANCELLED')&&(data.eventCreateDate > previousDate)" [hidden]="(data.startTime!=null && data.startTime < currentTime) && (data.eventCreateDate == currentDate)" routerLink="../create-event" class="editButton"><img src="assets/images/edit-all.png" alt="Angular Logo" class="image" title="EditAll"></a>
                                      <a (click)="deleteClick(data.eventId)" class="deleteButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus=='NEW'||data.eventStatus=='REJECTED')"><img src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
                                      <!-- <a (click)="completeClick(data.eventId,'COMPLETE')" class="completeButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==4||isbpgLeadAdmin||isNaacAdmin||data.isUserChapterLeadAdmin==true)&&(data.eventStatus=='COMPLETED')&&(data.eventAttendanceLoadCompleted==true)"><img src="assets/images/complete.png" alt="Angular Logo" class="image" title="Close"></a> -->
                                      <a (click)="viewEventDetails(data.eventId,'ATTENDENCE')" class="attendanceButton" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgAdmin||isbpgLeadAdmin||isNaacAdmin||data.isUserChapterLeadAdmin==true)&&(data.eventStatus=='SCHEDULED')&&(data.eventCreateDate <= today)" ><img src="assets/images/attendance.png" alt="Angular Logo" class="image" title="Attendance"></a>
                                      <a (click)="cancelClick(data.eventId,'CANCELLED')" class="cancelButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus=='SCHEDULED' || data.eventStatus=='PENDING') && !(data.eventStatus=='SCHEDULED' && data.eventCreateDate < previousDate)"  [hidden]="(data.startTime!=null && data.startTime < currentTime) && (data.eventCreateDate == currentDate)" ><img src="assets/images/reject.png" alt="Angular Logo" class="image" title="Cancel"></a>
                                      <a (click)="cancelAllClick(data.eventId,data.eventGroupId)" class="cancelButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus=='SCHEDULED')&&(data.eventCreateDate > previousDate) && (data.occurenceType!='once')"  [hidden]="(data.startTime!=null && data.startTime < currentTime) && (data.eventCreateDate == currentDate)" ><img src="assets/images/cancel-all.png" class="image" alt="Angular Logo" title="Cancel All"></a>
                                      <a (click)="eventReportClick(data.eventId)" class="cancelButton"><img src="assets/images/event_report.png" class="image" alt="Angular Logo" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&((data.eventStatus=='SCHEDULED')||(data.eventStatus=='COMPLETED')||(data.eventStatus=='CLOSED')||(data.eventStatus=='CANCELLED'))" title="Event Report"></a>
                        
                                    </td>
                                  </tr>
                            </tbody>
                        </table>
                        <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
                    </div>
                    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv p-0">
                        <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
                        <pagination-controls previousLabel="Prev" nextLabel="Next"
                            (pageChange)="pageChanged($event)"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
 <!-- for printing events-->
<div id="printEvents" [hidden]="true">
    <div class="mt-3 mb-2">
        <div class="text-center"
            *ngIf="this.siteNamePrint=='Select All' && this.bpgNamePrint=='Select All' && this.adminId!='1'">
            <h2>Events Report {{fiscalYearPrint}} </h2>
        </div>
        <div class="text-center" *ngIf="this.siteNamePrint!='Select All' && this.bpgNamePrint!='Select All'">
            <h2>Events Report for {{siteNamePrint}} - {{bpgNamePrint}} - {{fiscalYearPrint}} </h2>
        </div>
        <div class="text-center" *ngIf="this.siteNamePrint!='Select All' && this.bpgNamePrint=='Select All'">
            <h2>Events Report for All {{siteNamePrint}} - {{fiscalYearPrint}} </h2>
        </div>
    </div>
    <div *ngFor="let events of printEventsList">
        <div class="m-4 event-list event-list-outerdiv">
            <div class="date_span">
                <span class="date-style">{{events.eventDay}}</span><br>
                <span class="month-style">{{events.eventMonth}}</span>
            </div>
            <div class="events_info">
                <span class="filteredBpg">{{events.siteName}}</span><span
                    class="colon-padding filteredBpg">-</span><span class="filteredBpg">{{events.bpgName}}</span><span
                    class="colon-padding filteredBpg"> -
                </span><span class="event-name-span">{{events.eventName}}</span>
                <div class="event-time-loc">
                    <span class="common-line-height">{{events.startTime}}</span> to
                    <span>{{events.endTime}}</span><span> {{events.timeZone}} </span><br>
                    <div class="view-details-align">
                        <span class="common-line-height">{{events.description}}<span
                                class="common-line-height"></span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
